module.exports = __webpack_public_path__ + "static/media/asset-download.76669d9c.svg";